import { CourseService } from "@/common/api.service";
import { FETCH_COURSES, FETCH_DRAFT_COURSES, COURSE_SUBSCRIBE,RESET_STATE } from "./actions.type";
import { SET_COURSES, SET_DRAFT_COURSES, SET_ERROR,STATE_RESET } from "./mutations.type";

const initialState = () => {
    return {
        courses: [],
        draftCourses: [],
        courseerrors:[],
    }
}

let state = initialState()

const getters = {
    courses(state) {
        return state.courses
    },
    draftCourses(state) {
        return state.draftCourses
    }
}

const actions = {
    async [FETCH_COURSES](context, slug) {
        const { data } = await CourseService.get(slug)
        context.commit(SET_COURSES, data.data)
        return data;
    },
    async [FETCH_DRAFT_COURSES](context, slug) {
        const { data } = await CourseService.get(slug)
        context.commit(SET_DRAFT_COURSES, data.data)
        return data;
    },
    async [COURSE_SUBSCRIBE](context,params){
        return CourseService.subscribe(params.id,params)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, ( error.response.data.hasOwnProperty('errors') ?  error.response.data.errors :  error.response.data.message));
          return error
        });
    },

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_COURSES](state, coursedata) {
        state.courses = coursedata
    },
    [SET_DRAFT_COURSES](state, coursedata) {
        state.draftCourses = coursedata
    },
    [SET_ERROR](state, error) {
        state.courseerrors = error;
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};

